import { href, Navigate } from 'react-router';

import { pharmacyStorage } from '~features/auth';
import { ROUTES } from '~shared/routes';

export function RootRedirect() {
  const lastPharmacyId = pharmacyStorage.getLastPharmacyId();

  if (lastPharmacyId) {
    return (
      <Navigate
        to={href(ROUTES.index, { pharmacyId: lastPharmacyId })}
        replace
      />
    );
  }

  return <Navigate to={href(ROUTES.auth.loginCip)} />;
}
